<template>
  <div class="home">
    <div>
      <Header></Header>
      <div class="image-container">

        <div class="title">
          <h1>KO-technics Kft.</h1>
          <h4>{{ $t('home-title') }}</h4>
          <h3>{{ $t('home-motto') }}</h3>
        </div>
        <picture>
          <source media="(max-width:800px)" srcset="images/welding_header_phone.jpg">
          <img class="home-image" src="images/welding_header.jpg" alt="">
        </picture>
      </div>
    </div>

      <div class="service">
        <h2>{{ $t('home-services') }}</h2>
        <div class="service-cards">
          <div class="service-card-section">
            <div class="service-card" @click="goTo('/services')">
              <h3>{{ $t('home-services-1-title') }}</h3>
              <div class="service-card-lists">
                 <ul>
                <li v-for="item in (($tm('home-services-1-text')).split(',')).slice(0,5)">{{ $rt(item) }}</li>
              </ul>
              <ul>
                <li v-for="item in (($tm('home-services-1-text')).split(',')).slice(5)">{{ $rt(item) }}</li>
              </ul>
              </div>

            </div>

            <div class="service-card" @click="goTo('/fences')">
              <h3>{{ $t('home-services-2-title') }}</h3>
              <ul>
                <li>{{ $t('home-services-2-text') }}</li>
              </ul>
            </div>
          </div>

          <div class="service-card-section">
            <div class="service-card" @click="goTo('/services')">
              <h3>{{ $t('home-services-3-title') }}</h3>
              <ul>
                <li v-for="item in ($tm('home-services-3-text')).split(',')">{{ $rt(item) }}</li>
              </ul>
            </div>

            <div class="service-card" @click="goTo('/services')">
              <h3>{{ $t('home-services-4-title') }}</h3>
              <ul>
                <li v-for="item in ($tm('home-services-4-text')).split(',')">{{ $rt(item) }}</li>
              </ul>
            </div>
          </div>



        </div>
      </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref } from 'vue';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import router from '@/router';

function goTo(path) {
  router.push(path);
  window.scrollTo(0, 0);
}


</script>

<style lang="css">
.home {
  overflow-x: hidden;
}

/* .home-image {
  position: relative;
  z-index: 0;
  width: 100vw;
  height: auto;
  max-width: 100%;
  display: block;
}

.title {
  position: absolute;
  color: #FEF7F8;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
} */



.image-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.home-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #FEF7F8;
  text-align: center;
  z-index: 1;
  width: 100%;
}



.title h1 {
  font-size: 8vw;
  font-weight: 700;
  margin: 0;
}

.title h4{
  margin: 0;
  font-size: 2vw;
}

.title h3 {
  font-size: 1.5vw;
}

.service {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 100px;
  margin-bottom: 100px;
  width: 100%;
}

.service h2 {
  font-size: 5vw;
  font-weight: 700;
  margin: 0;
  color: #FEF7F8;
}

.service-cards {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #FEF7F8;
  margin-top: 80px;
  gap: 20px;
  cursor: pointer;
}

.service-card-section {
  display: flex;
  gap: 20px;
}

.service-card {
  background-color: #181818;
  border-radius: 10px;
  width: 40vw;
  min-height: 15vh;
  padding: 20px;
}

.service-card h3{
  font-weight: 700;
}

.service-card h3, .service-card p {
  margin-top: 10px;
}

.service-card-lists {
  display: flex;
  gap: 30px;
}

.service-card :not(h3) {
  font-size: 1vw;
}


@media (max-width: 900px) {
  .service-cards li {
    font-weight: 500;
  }
  .service-cards {
    margin-top: 30px;
  }
  .service-card-section {
    flex-direction: column;
  }
  .service-card {
    width: 70vw;
  }
  .service-card-lists {
    flex-direction: column;
    gap: 5px;
  }
  .service-card :not(h3) {
    font-size: 2vw;
  }
  .service-card h3 {
    font-size: 3vw;
  }
}

@media (max-width: 800px) {
  .title h1 {
  font-size: 10vw;
}

.title h4 {
  font-size: 3.5vw;
}

.title h3 {
  font-size: 3vw;
}
}

</style>
